const CryptoJS = require('crypto-js');

export const cifrarAES = (data: any, key: string) => {
    // Generar un IV aleatorio de 16 bytes
    const iv = CryptoJS.lib.WordArray.random(16);
    // Convertir la clave de hexadecimal a WordArray
    const keyHex = CryptoJS.enc.Hex.parse(key);

    // Encriptar los datos (asegúrate de que sea un JSON string)
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), keyHex, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    // Concatenar IV + texto cifrado (ambos son WordArray)
    const ivAndCiphertext = iv.concat(encrypted.ciphertext);

    // Convertir a Base64
    let base64String = CryptoJS.enc.Base64.stringify(ivAndCiphertext);

    // Reemplazar caracteres problemáticos para usar en URL (Base64URL)
    base64String = base64String
        .replace(/\+/g, '-')  // Reemplazar '+' por '-'
        .replace(/\//g, '_')  // Reemplazar '/' por '_'
        .replace(/=+$/, '');  // Eliminar '=' al final (opcional, para URL)

    return base64String;
};